import React, { forwardRef } from 'react';
import InputBase from 'component-library/atoms/InputBase';
import { IInputProps } from 'component-library/atoms/InputBase/InputBase';

const InputZipCode = forwardRef(
	(
		{
			className = '',
			value,
			...rest
		}: IInputProps,
		ref: any,
	) => {
		const formatZip = (zip: string) => {
			const onlyNumbers = zip.replace(/[^0-9]/g, '');
			return onlyNumbers;
		};

		const isZipValid = (val: string) => {
			return val.length === 5;
		};

		return (
			<InputBase
				{...rest}
				type='tel'
				className={`InputZipCode ${className}`}
				value={value}
				ref={ref}
				formatValue={formatZip}
				maxLength={5}
				isValid={isZipValid}
				inputMode='numeric'
			/>
		);
	},
);
InputZipCode.displayName = 'InputZipCode';

export default InputZipCode;
